import { Modal } from "antd";
import React, { useState } from "react";
import styled from "styled-components";
import { AddTokens } from "./AddTokens";
import { OrderComplete } from "./OrderComplete";
import { OrderSummary } from "./OrderSummary";
import { useStore } from "@stores/root-store";
import { useUserContext } from "@components/layout/superadmin-layout/SuperAdminLayout";

interface Props {
  isOpen?: boolean;
  closeModal?: (args: { fetchUserDetails: boolean }) => void;
  user: any;
}

export const AddTokensModal: React.FC<Props> = ({
  isOpen,
  closeModal,
  user,
}) => {
  const { updateUserDetails } = useUserContext();
  const [step, setStep] = React.useState(1);

  function handleCloseModal(params: { fetchUserDetails: boolean }) {
    setStep(1);
    closeModal(params);
  }

  const {
    user: { addPurchasedTokens },
  } = useStore(null);

  const [newCredits, setNewCredits] = useState(10); // 5 credits = 5000 tokens

  const tokens = newCredits * 1000;

  const handlePurchaseTokens = async () => {
    await addPurchasedTokens({
      email: user.email,
      new_purchased_credits: newCredits,
    }).then((res) => {
      if (res) {
        setStep(3);
        updateUserDetails();
      }
    });
  };

  const decreaseValue = () => {
    setNewCredits((prev) => (prev <= 10 ? 0 : prev - 10));
  };

  const increaseValue = () => {
    setNewCredits((prev) => prev + 10);
  };

  return (
    <Wrapper>
      <Modal
        onCancel={() => handleCloseModal({ fetchUserDetails: false })}
        open={isOpen}
        className={"customKeywordModal"}
        width={721}
        closable={false}
        footer={null}
      >
        {step === 1 && (
          <AddTokens
            closeModal={handleCloseModal}
            user={user}
            tokens={tokens}
            setNewValue={setNewCredits}
            newCredits={newCredits}
            decreaseValue={decreaseValue}
            increaseValue={increaseValue}
            setStep={setStep}
          />
        )}
        {step === 2 && (
          <OrderSummary
            closeModal={handleCloseModal}
            credits={newCredits}
            setStep={setStep}
            user={user}
            handlePurchaseTokens={handlePurchaseTokens}
          />
        )}
        {step === 3 && (
          <OrderComplete
            closeModal={handleCloseModal}
            user={user}
            credits={newCredits}
            setStep={setStep}
          />
        )}
      </Modal>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  .customKeywordModal {
    position: relative;

    .rc-dialog-content {
      .rc-dialog-close {
        color: #fff;
        font-size: 40px;
        right: -50px;
        top: -14px;
      }
    }
  }
`;
